import React from 'react';
import Characters from '../Characters/characters';

const CharacterList = ({character})=>{
    return(
        <div>
            <div className="cf">
                <div className="fl w-25 tc pv5">
                    NAME
                </div>
                <div className="fl w-25 tc pv5">
                    HOUSE
                </div>
                <div className="fl w-25 tc pv5">
                    ROLE
                </div>
                <div className="fl w-25 tc pv5">
                    BLOOD-STATUS
                </div>
            </div>
            <div className="potter__list">
                {
                    character.map((user,i) =>{
                        return (
                            <Characters 
                            key={i}
                            name={character[i].name}
                            house={character[i].house}
                            bloodstatus = {character[i].bloodStatus}
                            role= {character[i].role}
                            />
                        );
                    })
                }
            </div>
        </div>
    )
}

export default CharacterList
